<template>
  <div class="group">
    <heading tag="h5">{{ name }}</heading>
    <ul>
      <li v-for="media in list" :key="media.id">
        <button
          type="button"
          :class="{ selected: model === media.id }"
          @click="() => (model = media.id)"
        >
          <img :src="media.urlCompressed" />
        </button>
      </li>
    </ul>
  </div>
</template>
<script lang="ts" setup>
interface Props {
  name: string;
  list: MediaSchema[];
}
const model = defineModel<string>();
defineProps({
  name: null,
  list: null
});
const emit = defineEmits(["select"]);
</script>
<style lang="scss" scoped>
.group {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}
ul {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.2rem;
}
li {
  img {
    width: 100%;
    height: auto;
    aspect-ratio: 1;
  }
}
button {
  transition: background-color 300ms $ease-out-quad,
    border-color 300ms $ease-out-quad;
  border: 0.4rem solid transparent;
  border-radius: 50%;
  background-color: transparent;
  &.selected {
    border-color: var(--color_secondary);
    background-color: var(--color_secondary);
  }
}
</style>
